module.exports = __webpack_public_path__ + "static/media/gal2010-25.7fb026ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal2010/gal2010-25.jpg
// module id = 578
// module chunks = 0